(function () {
    'use strict';

    angular
        .module('app')
        .controller('ShowReviewsController', ShowReviewsController);

    ShowReviewsController.$inject = ['$http', '$stateParams', '$scope'];

    function ShowReviewsController($http, $stateParams, $scope) {
        var vm = this;
        vm.$onInit = init;
        vm.showUserProfile = [];

        $scope.$watch(function () {
                        return vm.reviews;
                    }, function (newValue, oldValue) {
            if (vm.reviews)
                vm.reviewMatrix = listToMatrix(vm.reviews, 2);
        });

        function listToMatrix(list, elementsPerSubArray) {
            if (!list || list == []) return [];

            var matrix = [], i, k;

            for (i = 0, k = -1; i < list.length; i++) {
                if (i % elementsPerSubArray === 0) {
                    k++;
                    matrix[k] = [];
                }

                matrix[k].push(list[i]);
            }

            return matrix;
        }

        function init() {
            if (vm.reviews)
                vm.reviewMatrix = listToMatrix(vm.reviews, 2);
        }
    }
})();
